import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './assets/localization/en.json'
import es from './assets/localization/es.json'

i18n.use(LanguageDetector).init({
  fallbackLng: 'en',

  react: {
    wait: true
  },

  resources: {
    en,
    es
  },
  // have a common namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',
  // This doesn't need to be on unless we have issues.
  debug: false,

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
    format: function (value, format, lng) {
      if (format === 'uppercase') return value.toUpperCase()
      return value
    }
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js